__turbopack_context__.v({
  "mergedRow": "table-module-scss-module__jpk5ZG__mergedRow",
  "table": "table-module-scss-module__jpk5ZG__table",
});
